import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

import { TellentAssistantMobileModalComponent } from '@core/tellent-assistant-mobile-smart-ui';
import { TellentAdoptedStylesheetsDirective, TellentThemeDirective } from '@core/tellent-smart-ui';
import { TellentWebComponent } from '@core/tellent-types';

// The host app (manage) mounts/unmounts this element itself, inside its own React-owned IonModal
// (see TellentAssistantMobileSheet.tsx) — presence in the DOM *is* the open state, so there is
// nothing to pass in and nothing to listen for here.
@Component({
  // NOTE: `makeTellentSelector` (defineCustomElements) turns the leading "x-" into "tellent-" —
  // it does NOT anchor the replace, so an "x-tellent-..." selector doubles up into
  // "tellent-tellent-...". Keep "tellent" out of this selector; the transform adds it.
  selector: 'x-assistant-mobile',
  template: `<tellent-assistant-mobile-modal />`,
  styleUrls: ['../../../styles.less'],
  styles: ':host { display: contents; }',
  hostDirectives: [TellentThemeDirective, TellentAdoptedStylesheetsDirective],
  imports: [TellentAssistantMobileModalComponent],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TellentAssistantMobileWrapComponent {}

export type TellentAssistantMobileWebComponent = TellentWebComponent<
  TellentAssistantMobileWrapComponent,
  never
>;
